// extracted by mini-css-extract-plugin
export default {"registerControlsText":"TableHeader_registerControlsText__-m3IT"};